import React, { useContext, useEffect, useState } from 'react';
import { Collapse, ListItemText, ListItemIcon, ListItem, List, Tooltip } from "@mui/material";
import { useComponents } from '../../hooks/useComponents';
import { convertirLetraMayus } from '../../helpers/convertirLetraMayus';
import { useNavigate } from 'react-router-dom';
import { AllInboxOutlined, AppsOutlined, CloudDownloadOutlined, DeleteOutline, DesktopWindowsOutlined, EmojiEmotionsOutlined, ExpandLessOutlined, ExpandMoreOutlined, FiberManualRecordOutlined, HelpOutlineOutlined, HubOutlined, LocalActivityOutlined, PersonOutlined, PollOutlined, PowerSettingsNew, StyleOutlined, TuneOutlined, WidgetsOutlined } from '@mui/icons-material';
import { AuthContext } from '../../contexts/AuthContext';

const ICONS = [
    { icon: <PersonOutlined /> },
    { 
        icon:  <LocalActivityOutlined />,
        childrens: [
            { 
                icon: <WidgetsOutlined fontSize='small' />,
                childrens: [
                    { icon: <FiberManualRecordOutlined fontSize='small' /> },
                    { icon: <FiberManualRecordOutlined fontSize='small' /> },
                    { icon: <FiberManualRecordOutlined fontSize='small' /> }
                ]
            },
            { 
                icon: <AppsOutlined fontSize='small' />,
                childrens: [
                    { icon: <FiberManualRecordOutlined fontSize='small' /> },
                    { icon: <FiberManualRecordOutlined fontSize='small' /> },
                    { icon: <FiberManualRecordOutlined fontSize='small' /> }
                ]
            }
        ]
    },
    {
        icon: <PollOutlined />,
        childrens: [
            { icon: <HubOutlined fontSize='small' /> },
            { icon: <StyleOutlined fontSize='small' /> },
            { icon: <HelpOutlineOutlined fontSize='small' /> },
            { icon: <StyleOutlined fontSize='small' /> },
            { icon: <EmojiEmotionsOutlined fontSize='small' /> }
        ]
    },
    {
        icon: <AllInboxOutlined />,
        childrens: [
            { icon: <DesktopWindowsOutlined fontSize='small' /> },
            { icon: <DeleteOutline fontSize='small' /> }
        ]
    },
    {
        icon: <CloudDownloadOutlined />,
        childrens: [
            { icon: <LocalActivityOutlined fontSize='small' /> },
            { icon: <PollOutlined fontSize='small' /> },
        ]
    },
    { 
        icon: <TuneOutlined />,
        childrens: [
            { icon: <PollOutlined fontSize='small' /> }
        ]
    },
    { icon: <PowerSettingsNew /> }
];

export const ListaMenu = () => {

    const [items, setItems] = useState();
    const { components } = useComponents();
    const { usuario: { rol: { nombre: rol }, permisos }, cerrarSesion } = useContext(AuthContext);
    const navigate = useNavigate();

    useEffect(() => {
        let unsubscribed = true;
        unsubscribed && setItems(components);

        return () => unsubscribed = false;
    }, [components]);

    const ejeuctarMenu = (e) => setItems(p => ([
        ...p,
        e.menu = !e.menu,
        e.childrens.map(c => c.menu = !e.menu && false)
    ]));

    const ejecutarSubMenu = (e) => setItems(p => ([
        ...p,
        e.menu = !e.menu
    ]));

    const action = (path) => navigate(path);

    return (
        <List
            component="nav"
            aria-labelledby="nested-list-subheader"
            style={{ width: "100%", maxWidth: 360, overflowY: 'auto', overflowX: 'hidden' }}
        >
            {items?.map((father, index) => !father?.childrens ? (
                <div key={ father?.name }>
                    {
                        (rol?.includes('admin') || permisos[index]?.active) && (
                            <Tooltip title={ convertirLetraMayus(father?.name ) } placement="right">
                                <ListItem button onClick={() => father?.path ? action(father?.path) : cerrarSesion() }>
                                    <ListItemIcon>
                                        { ICONS[index]?.icon }
                                    </ListItemIcon>
                                    <ListItemText primary={convertirLetraMayus(father?.name)} primaryTypographyProps={{ fontWeight: 'bold', color: "#424242" }} />
                                </ListItem>
                            </Tooltip>
                        )
                    }
                </div>
            ) : (
                <div key={ father?.name }>
                    {
                        (rol?.includes('admin') || permisos[index]?.active) && (
                            <>
                                <Tooltip title={ convertirLetraMayus(father?.name) } placement="right">
                                    <ListItem button onClick={() => ejeuctarMenu(father)}>
                                        <ListItemIcon>{ ICONS[index].icon }</ListItemIcon>
                                        <ListItemText primary={ convertirLetraMayus(father?.name) } primaryTypographyProps={{ fontWeight: 'bold', color: "#424242" }} />
                                        { father?.menu ? <ExpandLessOutlined /> : <ExpandMoreOutlined /> }
                                    </ListItem>
                                </Tooltip>

                                { 
                                    father?.childrens?.map((child, ind) => !child?.childrens ? (
                                        <div key={ child?.name }>
                                            {
                                                (rol?.includes('admin') || permisos[index]?.childrens[ind]?.active) && (
                                                    <Collapse in={father?.menu} timeout="auto" unmountOnExit sx={{ marginLeft: 1 }}>
                                                        <List component="div" disablePadding>
                                                            <Tooltip title={ convertirLetraMayus(child?.name) } placement="right">
                                                                <ListItem button onClick={ () => action(child?.path) }>
                                                                    <ListItemIcon>{ ICONS[index]?.childrens[ind]?.icon }</ListItemIcon>
                                                                    <ListItemText primary={convertirLetraMayus(child?.name) } primaryTypographyProps={{ fontWeight: '500', fontSize: 15, color: "#424242" }} />
                                                                </ListItem>
                                                            </Tooltip>
                                                        </List>
                                                    </Collapse>
                                                )
                                            }
                                        </div>
                                    ) : (
                                        <div key={ child?.name }>
                                            {
                                                (rol?.includes('admin') || permisos[index]?.childrens[ind]?.active) && (
                                                    <>
                                                        <Collapse in={father?.menu} timeout="auto" unmountOnExit sx={{ marginLeft: 1 }}>
                                                            <Tooltip title={ convertirLetraMayus(child?.name) } placement="right">
                                                                <ListItem button onClick={() => child?.childrens?.length <= 0 ? action(child?.path) : ejecutarSubMenu(child, index - 1)}>
                                                                    <ListItemIcon>{ ICONS[index]?.childrens[ind]?.icon }</ListItemIcon>
                                                                    <ListItemText primary={ convertirLetraMayus(child?.name) } primaryTypographyProps={{ fontWeight: '500', fontSize: 15, color: "#424242" }} />
                                                                    { child?.menu ? <ExpandLessOutlined /> : <ExpandMoreOutlined /> }
                                                                </ListItem>
                                                            </Tooltip>
                                                        </Collapse>

                                                        { 
                                                            child?.childrens?.map((c, i) => (
                                                                <div key={ c?.name }>
                                                                    {
                                                                        (rol?.includes('admin') || permisos[index]?.childrens[ind]?.childrens[i]?.active) && (
                                                                            <Collapse in={child?.menu} timeout="auto" unmountOnExit sx={{ marginLeft: 2 }}>
                                                                                <List component="div" disablePadding onClick={ () => action(c?.path) }>
                                                                                    <Tooltip title={ convertirLetraMayus(c?.name) } placement="right">
                                                                                        <ListItem button>
                                                                                            <ListItemIcon>{ ICONS[index]?.childrens[ind]?.childrens[i]?.icon }</ListItemIcon>
                                                                                            <ListItemText primary={ convertirLetraMayus(c?.name) } primaryTypographyProps={{ fontSize: 14, color: "#424242" }} />
                                                                                        </ListItem>
                                                                                    </Tooltip>
                                                                                </List>
                                                                            </Collapse>
                                                                        )
                                                                    }
                                                                </div>
                                                            )) 
                                                        }
                                                    </>
                                                )
                                            }
                                        </div>
                                    )) 
                                }
                            </>
                        )
                    }           
                </div>
            ))}
        </List>
    );
}